'use strict';

const jQuery = require('jquery');
const Translator = require('./../../../core/translator');

const Zone = require('./../../../services/structure/zone');
const Tpl = require('./../templates/matomo.hbs');
const FormBuilder = require('../../../services/form');
const Notifier = require('../../../services/notifier');
const Loader = require('../../../services/loader');
const UserPrefRepo = require('../../content/repository/UserPreferenceRepository');
const zone = require('../../../services/structure/zone');
const Container = require('../../../core/container');

/**
 * Handle on menu click.
 */
module.exports.onMenuClick = function() {
  let $container = jQuery(Tpl());

  Loader.start($container);
  buildForm($container);
  Loader.stop($container);

  Zone.addLayer(Translator.translate('matomo'), `<p>${Translator.translate('matomo_description')}</p>`);
  Zone.setFullPanel(Translator.translate('matomo_full_panel'), $container);
};

/**
 * Build form.
 * @param {object} $container
 */
const buildForm = function($container) {
  let $cloudCol = $container.find('div.cloud-col-6');

  UserPrefRepo.find('matomo-analytics').done((matomoData) => {
    let form = FormBuilder.getForm({
      'elements': {
        'tracker-url': {
          'type': 'text',
          'label': Translator.translate('matomo_tracker_url_label'),
          'value': typeof matomoData === 'object' ? matomoData['tracker_url'] : '',
        },
        'site-id': {
          'type': 'text',
          'label': Translator.translate('matomo_site_id_label'),
          'value': typeof matomoData === 'object' ? matomoData['site_id'] : '',
        },
      },
      'form': {
        'submit_label': Translator.translate('save'),
      },
    });

    $cloudCol.append(form.render());

    form.on('submit', onSubmit);
  });
};

/**
 * Handle on submit.
 * @param {object} data Values form.
 */
const onSubmit = function(data) {
  data['tracker-url'] && data['site-id'] ?
    UserPrefRepo.save('matomo-analytics', {'tracker_url': data['tracker-url'], 'site_id': data['site-id']}) :
    UserPrefRepo.del('matomo-analytics');

  Notifier.success(Translator.translate('parameters_saved'));

  zone.hidePanels(Container.get('$smallPanel'));
};

